import styled, { css } from "styled-components";
import media from "../../utils/media";
import { MAGIC_STYLED_APP_BAR_MOBILE_GRADIENT_START_PX_NUMBER } from "../AppBar/AppBar";

interface ViewerProps {
  wide?: boolean;
  numOfParallels?: number;
}

const Viewer = styled.section<ViewerProps>`
  background: ${props => props.theme.background};
  display: flex;
  flex-direction: column;
  min-height: 100%;
  padding-top: ${MAGIC_STYLED_APP_BAR_MOBILE_GRADIENT_START_PX_NUMBER}px; // AppBar
  box-sizing: border-box;

  ${media.desktop`
    border-radius: 2px;
    margin: auto;
    padding-top: 0;
    width: 86%;
    max-width: calc(14rem + 65ch);
    box-sizing: border-box;
    position: relative;
    ${(props: ViewerProps) =>
      props.wide &&
      css`
        max-width: calc(14rem + ${((props.numOfParallels || 0) + 1) * 65}ch);
        width: 100%;
      `};
  `};
`;

export default Viewer;
